import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        Made with <span className="footer-heart">♥</span> especially for NAME_HEREi&apos;s birthday on
        DATE_HERE.
      </p>
      <a href="#top" className="footer-link">
        Back to top
      </a>
    </footer>
  );
}
